import * as actions from '../actions';
import { Action } from '../actions';

export type WorkspaceSourceCreationInfo =
  | { _tag: 'course'; courseId: number }
  | { _tag: 'template'; templateKey: string };

export type WorkspaceTemplate =
  | { _tag: 'course'; courseId: number; title: string }
  | {
      _tag: 'template';
      key: string;
      title: string;
    };

export type Workspace = {
  id: string;
  source:
    | {
        _tag: 'template';
        templateId: null | number;
      }
    | {
        _tag:
          | 'workspace'
          | 'github'
          | 'integration'
          | 'project'
          | 'projectTemplate'
          | 'rdocs'
          | 'course'
          | 'certificationTemplate';
      };
};

export type WorkspaceNotes =
  | { type: 'success'; workspace: Workspace }
  | { type: 'loading' | 'error' };

export type NotesState = {
  workspaceNotes?: WorkspaceNotes;
  workspaceTemplate: WorkspaceTemplate | null;
};

const initialState: NotesState = {
  workspaceNotes: undefined,
  workspaceTemplate: null,
};

export default (state = initialState, action: Action): NotesState => {
  switch (action.type) {
    case actions.BOOT_SUCCEEDED:
      return {
        ...state,
        workspaceTemplate: action.entities.workspaceTemplate,
      };
    case actions.SET_WORKSPACE_NOTES:
      return {
        ...state,
        workspaceNotes: action.data,
      };
    default:
      return state;
  }
};
